import { API } from "aws-amplify";

async function fetchEventsWithLLMQuery(
  stream: VideoStream,
  query: string,
  timestampBefore: number,
  timestampAfter: number
): Promise<APIResponse<{ timestamp: number, s3_url?: string }[]>> {

  try {
    const path = `/eventqueries/${stream.kvsName}/query`;
    const body = { query, timestamp_after: timestampAfter, timestamp_before: timestampBefore } 
    const data: APIResponse<{ timestamp: number, s3_url: string }[]> = await API.post('api-service', path, { body });

    return data;
  } catch (e) {
    console.log(e)
    throw e;
  }
}

export default fetchEventsWithLLMQuery;
